import { ButtonColor, ButtonSize, ButtonVariant } from "enums/Button";
import styled, { DefaultTheme } from "styled-components";
import PreLoader from "../PreLoader/PreLoader";
import { variantStyles } from "./helperStyles";

const buttonColorMap: Partial<Record<ButtonColor, keyof DefaultTheme>> = {
  [ButtonColor.Primary]: 'buttonPrimary',
  [ButtonColor.Secondary]: 'buttonSecondary',
};

const resolveButtonColor = (colorKey: ButtonColor, theme: DefaultTheme): string =>
  theme[buttonColorMap[colorKey] ?? colorKey] as string;

interface CustomButtonProps {
  $variant: ButtonVariant;
  color: ButtonColor;
  size: ButtonSize;
}

export const CustomButton = styled.button<CustomButtonProps>`
  ${({ theme }) => theme.range("font-size", "13px", "14px")};
  cursor: pointer;
  border-radius: 7px;
  padding: ${(props) =>
    props.size === ButtonSize.Large ? "12px 30px" : "9px 20px"};
  transition:
    box-shadow 0.2s,
    background-color 0.2s,
    color 0.2s,
    border 0.2s;

  ${({ color, $variant, theme }) => variantStyles[$variant](resolveButtonColor(color, theme), theme)};

  ${(props) => props.theme.xs`
    padding: 9px 20px;
  `}
`;

export const Spinner = styled(PreLoader)`
  margin-right: 5px;
  width: 20px;
  height: 14px;
  transform-origin: 0 -2px;
  transform: scale(0.3);
`;
